export default "__VITE_ASSET__Bhp$iSLR__"